export const debounce = (fn, delay, timeoutRef) => {
    function debouncedFn() {
      window.clearTimeout(timeoutRef.current);
      timeoutRef.current = window.setTimeout(() => {
        fn();
      }, delay);
    }
  
    return debouncedFn;
  };